//  @flow

import React from 'react';
import { withTranslation } from 'react-i18next';

import LinkSection from './LinkSection';
import ImageBlurFallback from '../../ImageBlurFallback';

import CompanyLogo_webp from '../../../Assets/v2/header/logo.webp';
import CompanyLogo_png from '../../../Assets/v2/header/logo.png';
import CompanyLogo_fallback from '../../../Assets/fallbacks/header/logo.jpg';

import './style1.css';
import { debounce } from '../../../helpers/helper';

type HeaderProps = {};

type HeaderState = {
  isLinksVisible: boolean,
  scrollingDown: boolean
};

class Header extends React.Component<HeaderProps, HeaderState> {
  navRef: any;

  constructor(props: HeaderProps) {
    super(props);
    this.state = {
      isLinksVisible: false,
      scrollingDown: false
    };

    this.navRef = React.createRef();
  }

  componentDidMount() {
    this.setScollListner();
  }

  setScollListner = () => {
    this.prevVal = 0;
    window.addEventListener(
      'scroll',
      debounce(() => {
        requestAnimationFrame(() => {
          if (window.pageYOffset > this.prevVal) {
            this.updateScrollStatus(true);
          } else {
            this.updateScrollStatus(false);
          }
          this.prevVal = window.pageYOffset;
        });
      }, 300)
    );
  };

  updateScrollStatus = status => {
    if (this.state.scrollingDown !== status) {
      this.setState({
        scrollingDown: status
      });
    }
  };

  toggleLinks = () => {
    // this.setState(prevState => ({ isLinksVisible: !prevState.isLinksVisible }));
  };

  setRef = (r: any) => {
    this.navRef = r;
  };
  render = () => {
    const { t } = this.props;
    const { scrollingDown } = this.state;
    return (
      <div style={{ width: 'auto', height: 'auto' }} ref={this.setRef}>
        <div
          style={{
            animation: scrollingDown
              ? 'slideOutTop 500ms ease forwards'
              : 'slideInTop 500ms ease forwards'
          }}
          className={`nav-header`}>
          <div className="nav-content">
            <div className="nav-logo">
              <ImageBlurFallback
                className="nav-logo-img"
                fallbackImage={CompanyLogo_fallback}
                webpImage={CompanyLogo_webp}
                src={CompanyLogo_png}
                alt={t('companylogo')}
              />
            </div>
            <LinkSection />
          </div>
        </div>

        {/** ==== for mobile view====== */}
        <div className="nav-header-mobile">
          <div className="nav-logo-row">
            <ImageBlurFallback
              fallbackImage={CompanyLogo_fallback}
              className="nav-logo-row-img"
              webpImage={CompanyLogo_webp}
              src={CompanyLogo_png}
              alt={t('companylogo')}
            />

            <button onClick={this.toggleLinks}>
              <i className=" fa fa-bars input-icon" />
            </button>
            <LinkSection
              active={this.state.isLinksVisible}
              isMobileView={true}
            />
          </div>
        </div>
      </div>
    );
  };
}

export default withTranslation()(Header);



// WEBPACK FOOTER //
// ./src/Components/Nav/Header/index.js